import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { path } from '@/routes/Routes.helpers';
import { TaskStatusT } from '@/constants/statuses';

export const PROGRESS_PROCESSES = {
    Upload: 'Upload',
    OutfitTryOn: 'OutfitTryOn',
} as const;

export type ProgressProcessT =
    (typeof PROGRESS_PROCESSES)[keyof typeof PROGRESS_PROCESSES];

export type ProcessIconT = 'failed';

interface ButtonConfigIF {
    text: string;
    link?: string;
}

interface StatusConfigIF {
    label?: string;
    button?: ButtonConfigIF;
    icon?: ProcessIconT;
}

export type ProgressConfigT = Record<TaskStatusT, StatusConfigIF>;

interface ProgressStateIF {
    progressStatus?: TaskStatusT;
    progressProcess?: ProgressProcessT;
    progressConfig: ProgressConfigT;
    isAddPhotoWidgetOpen: boolean;
}

const DEFAULT_CONFIG: ProgressConfigT = {
    Uploading: { label: 'Загружаем' },
    Pending: { label: 'Ожидаем ответа' },
    Processing: { label: 'Обрабатываем' },
    Completed: { label: 'Готово' },
    Failed: { label: 'Ошибка загрузки', icon: 'failed' },
    FailedAll: { label: '' },
    WaitingUser: {
        label: 'Новые вещи готовы к добавлению',
        button: {
            text: 'Посмотреть',
            link: path('wardrobeAdd'),
        },
    },
};

const initialState: ProgressStateIF = {
    progressConfig: DEFAULT_CONFIG,
    isAddPhotoWidgetOpen: false,
};

export const progressSlice = createSlice({
    name: 'progressSlice',
    initialState,
    reducers: {
        setProgressStatus: (state, action: PayloadAction<TaskStatusT>) => {
            state.progressStatus = action.payload;
        },

        updateProgressConfig: (
            state,
            action: PayloadAction<Partial<ProgressConfigT>>,
        ) => {
            const updates = action.payload;
            for (const status of Object.keys(updates) as TaskStatusT[]) {
                const config = updates[status];
                if (config) {
                    state.progressConfig[status] = {
                        ...state.progressConfig[status],
                        ...config,
                    };
                }
            }
        },

        setIsAddPhotoWidgetOpen: (state, action: PayloadAction<boolean>) => {
            state.isAddPhotoWidgetOpen = action.payload;
        },

        resetProgress: () => initialState,

        setProgressProcess: (
            state,
            action: PayloadAction<ProgressProcessT>,
        ) => {
            state.progressProcess = action.payload;
        },
    },
});

export const {
    setProgressStatus,
    setProgressProcess,
    updateProgressConfig,
    resetProgress,
    setIsAddPhotoWidgetOpen,
} = progressSlice.actions;
